import Image from "next/image";
import Link from "next/link";

import { postPath } from "@/lib/blog/paths";
import { topicForPost } from "@/lib/blog/topics";
import { ghostImage, type BlogPostSummary } from "@/lib/ghost";
import { formatDate } from "@/lib/utils";

const BlogPostCard = ({ post, priority = false }: { post: BlogPostSummary; priority?: boolean }) => {
  const label = topicForPost(post)?.name ?? post.primary_tag?.name;

  return (
    <Link href={postPath(post.slug)}>
      <article className="group relative isolate flex aspect-[4/5] flex-col justify-end overflow-hidden rounded-2xl bg-gray-900 p-6">
        <Image
          className="absolute inset-0 -z-20 size-full object-cover transition-transform duration-300 group-hover:scale-105"
          src={ghostImage(post.feature_image, 600)}
          alt={post.title}
          fill
          sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
          priority={priority}
          draggable={false}
        />
        <div className="absolute inset-0 -z-10 bg-gradient-to-t from-gray-900 via-gray-900/40" />

        <div className="space-y-2">
          {label && (
            <span className="inline-block rounded-full bg-white/10 px-2.5 py-0.5 text-xs text-gray-300 backdrop-blur-sm">
              {label}
            </span>
          )}
          <h3 className="text-lg/6 font-semibold text-white">{post.title}</h3>
          {post.published_at && (
            <time dateTime={post.published_at} className="text-[11px] text-white/70">
              {formatDate(post.published_at)}
            </time>
          )}
        </div>
      </article>
    </Link>
  );
};

export default BlogPostCard;
